/** @jsx jsx */
import React from 'react';
import { jsx } from '@compiled/react';
import { CommentAuthor } from '@atlaskit/comment';
import { Text } from '@atlaskit/primitives/compiled';

import WithProfileCard from '@atlassian/jira-issue-view-internal-profilecard-next/src/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useCommentContext } from './CommentContextProvider.tsx';

const Separator = () => {
	if (!expVal('issue_view_activity_timeline', 'isActivityTimelineEnabled', false)) {
		return <>&nbsp;</>;
	}
	return null;
};
const AkCommentAuthorWrapper = () => {
	const { isDeleted, authorDisplayName, authorAdditionalInfo, author } = useCommentContext();

	if (isDeleted) {
		return null;
	}
	return (
		<WithProfileCard
			userAccount={author}
			analyticsData={{ trigger: 'comment-author' }}
			shouldTruncate
		>
			<CommentAuthor>
				<Text weight="bold">{authorDisplayName}</Text>
				<Separator />
				{authorAdditionalInfo}
			</CommentAuthor>
		</WithProfileCard>
	);
};
export default AkCommentAuthorWrapper;
